export default __webpack_public_path__ + "static/media/Group39698.eced2f9a.png";